import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import NotFound from './NotFound';
import Events from './Events';
import Event from './Event';
import Photo from './Photo';

const Routing: React.FC = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/events/:year" element={<Events />} />
                <Route path="/events" element={<Events />} />
                <Route path='/event/:id/:catId' element={<Event />} />
                <Route path="/event/:id" element={<Event />} />
                <Route path="/event" element={<Event />} />
                <Route path='/photo/:eventId/:photoId' element={<Photo />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}

export default Routing;